module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-6-934a80c745b8d0b0e990478de1e7088c.jpg";